const constraints = {
	email: {
		presence: {
			message: "^Please enter an email address"
		},
		email: {
			message: "^Please enter a valid email address",
			allowEmpty: false
		}
	},
	password: {
		presence: {
			message: "^Please enter a password",
			allowEmpty: false
		},
		length: {
			minimum: 10,
			message: "^Your password must be at least 10 characters"
		}
	}
}

export default constraints
